import "./simple-list.css.js";
const s = {
  modifiers: {
    link: "pf-m-link",
    current: "pf-m-current"
  },
  simpleList: "pf-v6-c-simple-list",
  simpleListItemLink: "pf-v6-c-simple-list__item-link",
  simpleListSection: "pf-v6-c-simple-list__section",
  simpleListTitle: "pf-v6-c-simple-list__title"
};
export {
  s as default
};
